import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface IProps {
  title: string;
  value: React.ReactNode;
  description?: React.ReactNode;
  primary?: boolean;
}

const NpsResultsMetricCard: React.FC<IProps> = ({
  title,
  value,
  description,
  primary,
}) => (
  <Card>
    <CardHeader className="p-4 pb-2">
      <CardTitle className="text-sm font-medium text-muted-foreground">
        {title}
      </CardTitle>
    </CardHeader>
    <CardContent className="flex flex-col gap-1 p-4 pt-0">
      <div
        className={
          primary ? 'text-3xl font-semibold' : 'text-2xl font-semibold'
        }
      >
        {value}
      </div>
      {description && (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}
    </CardContent>
  </Card>
);

export default NpsResultsMetricCard;
